import { ReactElement } from 'react'
import Benefit from './Benefit'
import benefits from './Benefit/benefits'
import * as S from './styled'

export default function Benefits (): ReactElement {
  return <S.Container id="beneficios">
    <h2>Benefícios exclusivos</h2>

    <S.Content>
      {benefits.map(({ icon: Icon, ...rest }) => <Benefit key={rest.title} icon={<Icon />} {...rest} />)}
    </S.Content>
  </S.Container>
}
